"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../../../theme"));
exports.MainContainer = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  height: 8px;\n  width: 8px;\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0 2px;\n  transition: 0.3s opacity;\n\n  opacity: ", ";\n"], ["\n  cursor: pointer;\n  height: 8px;\n  width: 8px;\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0 2px;\n  transition: 0.3s opacity;\n\n  opacity: ", ";\n"])), theme_1.default.colorsPalette.gray.darker, function (_a) {
    var active = _a.active;
    return (active ? "0.4" : "1");
});
var templateObject_1;
//# sourceMappingURL=styles.js.map